import React, { useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Sidebar.css';
import { ThemeContext } from '../ThemeContext';
import newChatIcon from '../icons/new-chat.svg'

const Sidebar = ({ onClearChat, onSelectExample, onCloseSidebar }) => {
  const { user, logout } = useAuth();
  const { theme } = useContext(ThemeContext);
  const exampleQuestions = [
    "🏢 Best residential projects in Gurgaon?",
    "🏢 3BHK apartments in Sector 106?",
    "🌳 3BHK in Whiteland Urban Resort?",
    "⏰ What should I do if my builder delays possession?",
    "🏛️ How HARERA can be helpful for me?"
  ];  

  const handleLogout = () => {
    logout();
  };

  // Get guest name from localStorage if available.
  const storedGuestName = localStorage.getItem('guestName');
  
  // Determine welcome name
  const welcomeName = user && user.name ? user.name : (storedGuestName ? storedGuestName : "Guest");

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-header">
          <h2 style={{ textAlign: 'center' }}>
            Welcome <span style={{ color: 'blue' }}>{welcomeName}</span> <br /> to <br /> AI Real Estate Buddy
          </h2>
        </div>
        <div className='new-chat-section'>
          <div className='new-chat-button-container'> 
            <button className='new-chat-button' onClick={() => {
                onClearChat('new');
                onCloseSidebar();
              }}>
              <img src={newChatIcon} alt='New Chat' width='20px' height='20px'/>
              <p>New chat</p>
            </button>
          </div>
        </div>
        <div className="sidebar-section">
          <button className="refer-earn-btn" onClick={() => {
            onSelectExample('open_refer_modal');  // trigger to open ReferALeadModal
            onCloseSidebar();
          }}>
            🎁 Refer & Earn
          </button>
        </div>
        <div className="sidebar-section">
          <p className="sidebar-section-title">Sample Questions</p>
          {exampleQuestions.map((q, i) => (
            <button key={i} className="example-btn" onClick={() => {
              onSelectExample(q);
              onCloseSidebar();
            }}>
              {q}
            </button>
          ))}
        </div>
      </div>
      <div className="sidebar-footer">
        <p>Realtyseek.ai can make mistakes, so check carefully.</p>
      </div>
    </div>
  );  
};

export default React.memo(Sidebar);
